import InlineWorker from 'inline-worker'
import Resampler from './resampler'
import i18n from '@/locales'
export class Recorder {
  config = {
    bufferLen: 4096,
    numChannels: 1, // 默认单声道
    onaudioprocess: null,
    canvas: 'canvas',
  }

  recording = false

  callbacks = {
    getBuffer: [],
    encodeSpeex: [],
    exportWAV: [],
  }

  constructor(source, cfg) {
    Object.assign(this.config, cfg)
    this.context = source.context
    this.analyserNode = this.context.createAnalyser()
    this.analyserNode.fftSize = 2048
    this.analyserNode.minDecibels = -90
    this.analyserNode.maxDecibels = -10
    this.analyserNode.smoothingTimeConstant = 0.85
    const bufferLength = this.analyserNode.frequencyBinCount
    this.waveArray = new Uint8Array(bufferLength)
    this.analyserNode.getByteTimeDomainData(this.waveArray)
    this.getSpeexData = this.config.getSpeexData
    this.node = (
      this.context.createScriptProcessor || this.context.createJavaScriptNode
    ).call(
      this.context,
      this.config.bufferLen,
      this.config.numChannels,
      this.config.numChannels
    )

    this.resampler = new Resampler(
      this.context.sampleRate,
      this.config.sampleRate,
      this.config.numChannels,
      this.node.bufferSize
    )

    this.node.onaudioprocess = event => {
      if (!this.recording) {
        return false
      }
      let buffers = []
      for (let channel = 0; channel < this.config.numChannels; channel++) {
        let inputBuffer = event.inputBuffer.getChannelData(channel)
        let samples
        if (this.context.sampleRate != this.config.sampleRate) {
          samples = this.resampler.resampler(inputBuffer)
        } else {
          samples = inputBuffer
        }
        buffers.push(samples)
      }
      // 发送给worker
      this.worker.postMessage({
        command: 'record',
        buffer: buffers,
      })
      if (this.config.onaudioprocess) {
        this.config.onaudioprocess(buffers)
      }
    }

    source.connect(this.node)
    source.connect(this.analyserNode)

    this.worker = new InlineWorker(function() {
      let codec
      let recording
      let recLength = 0,
        recBuffers = [],
        sampleRate,
        numChannels
      self.onmessage = function(e) {
        switch (e.data.command) {
          case 'init':
            init(e.data.config)
            break
          case 'record':
            record(e.data.buffer)
            break
          case 'encodeSpeex':
            encodeSpeex()
            break
          case 'exportWAV':
            exportWAV(e.data.type)
            break
          case 'getBuffer':
            getBuffer()
            break
          case 'clear':
            clear()
            break
          case 'setRecording':
            setRecording(e.data.status)
            break
        }
      }

      function initSpeex() {
        codec = new Speex({
          quality: 8,
          mode: 1,
          bits_size: 70,
        })
      }

      function init(config) {
        const speexPath =
          config.origin + process.env.BASE_URL + 'plugins/speex.min.js'
        importScripts(speexPath)
        sampleRate = config.sampleRate
        numChannels = config.numChannels
        desiredSamplingRate = config.desiredSamplingRate
        initSpeex()
        initBuffers()
      }

      function record(inputBuffer) {
        for (var channel = 0; channel < numChannels; channel++) {
          recBuffers[channel].push(inputBuffer[channel])
        }
        recLength += inputBuffer[0].length
      }

      function setRecording(status) {
        recording = status
      }
      /**
       * encode speex
       */
      function encodeSpeex() {
        let reindex = 0
        const ENCODE_BUFFER_LENGTH = 3200
        const PAGE_SIZE = 320
        let encodeing = false
        let encodeItimer = setInterval(() => {
          if (encodeing) return
          var buffers = []
          let samples = []
          for (var channel = 0; channel < numChannels; channel++) {
            let buffer = mergeBuffers(recBuffers[channel], recLength)
            let sampleChunk
            if (recording == true) {
              sampleChunk = buffer.subarray(
                reindex,
                reindex + ENCODE_BUFFER_LENGTH
              )
            } else {
              sampleChunk = buffer.subarray(reindex)
              encodeItimer && clearInterval(encodeItimer)
              encodeItimer = null
            }
            samples.push(sampleChunk)
            buffers.push(buffer)
          }
          //录音状态，并且当前需要编码的长度不等于指定的编码长度
          if (
            (recording == true && samples[0].length != ENCODE_BUFFER_LENGTH) ||
            !samples[0].length
          ) {
            return
          }
          encodeing = true
          reindex += samples[0].length
          var interleaved =
            numChannels === 2 ? interleave(samples[0], samples[1]) : samples[0]
          var buffer = new ArrayBuffer(interleaved.length * 2)
          const view = new DataView(buffer)
          floatTo16BitPCM(view, 0, interleaved)
          let int16Buffer = new Int16Array(view.buffer)
          const pageCount = Math.ceil(int16Buffer.length / PAGE_SIZE)
          let pageNum = 0
          let spxdatas = []
          while (pageNum < pageCount) {
            const chunk = new Int16Array(PAGE_SIZE)
            for (let i = 0; i < int16Buffer.length; i++) {
              let idx = i + PAGE_SIZE * pageNum
              chunk[i] = int16Buffer[idx]
              if (i >= PAGE_SIZE * (pageNum + 1) - 1) {
                break
              }
            }
            const encoded = codec.encode(chunk)
            const spxdata = new Uint8Array(encoded[0])
            const blob = new Blob([spxdata])
            let reader = new FileReaderSync() //同步，有延迟
            let result = reader.readAsDataURL(blob)
            let data = result.substr(result.indexOf(';base64,') + 8)
            spxdatas.push(data)
            pageNum++
          }
          encodeing = false
          let isComplate = !recording && reindex == buffers[0].length
          self.postMessage({
            command: 'getSpeexData',
            data: {
              spxdata: spxdatas,
              status: isComplate,
              view: view,
            },
          })
        }, 200)
      }

      /**
       * 导出wav
       * @param type
       * @param desiredSamplingRate 期望的采样率
       */
      function exportWAV(type) {
        var buffers = []
        for (var channel = 0; channel < numChannels; channel++) {
          var buffer = mergeBuffers(recBuffers[channel], recLength)
          // // 需要转换采样率
          // if (desiredSamplingRate != sampleRate) {
          //   // 插值去点
          //   buffer = interpolateArray(buffer, desiredSamplingRate, sampleRate)
          // }
          buffers.push(buffer)
        }
        var interleaved =
          numChannels === 2 ? interleave(buffers[0], buffers[1]) : buffers[0]
        var dataview = encodeWAV(interleaved, desiredSamplingRate)
        var audioBlob = new Blob([dataview], {
          type: type,
        })
        self.postMessage({
          command: 'exportWAV',
          data: audioBlob,
        })
      }
      /**
       * 转换采样率
       * @param data
       * @param newSampleRate 目标采样率
       * @param oldSampleRate 原始数据采样率
       * @returns {any[]|Array}
       */
      function interpolateArray(data, newSampleRate, oldSampleRate) {
        var fitCount = Math.round(data.length * (newSampleRate / oldSampleRate))
        var newData = new Array()
        var springFactor = new Number((data.length - 1) / (fitCount - 1))
        newData[0] = data[0] // for new allocation
        for (var i = 1; i < fitCount - 1; i++) {
          var tmp = i * springFactor
          var before = new Number(Math.floor(tmp)).toFixed()
          var after = new Number(Math.ceil(tmp)).toFixed()
          var atPoint = tmp - before
          newData[i] = linearInterpolate(data[before], data[after], atPoint)
        }
        newData[fitCount - 1] = data[data.length - 1] // for new allocation
        return newData
      }

      function linearInterpolate(before, after, atPoint) {
        return before + (after - before) * atPoint
      }

      function getBuffer() {
        var buffers = []
        for (var channel = 0; channel < numChannels; channel++) {
          var buffer = mergeBuffers(recBuffers[channel], recLength)
          buffers.push(buffer)
        }
        self.postMessage({
          command: 'getBuffer',
          data: buffers,
        })
      }

      function clear() {
        recLength = 0
        recBuffers = []
        initBuffers()
      }

      function initBuffers() {
        for (let channel = 0; channel < numChannels; channel++) {
          recBuffers[channel] = []
        }
      }

      function mergeBuffers(recBuffers, recLength) {
        let result = new Float32Array(recLength)
        let offset = 0
        for (let i = 0; i < recBuffers.length; i++) {
          result.set(recBuffers[i], offset)
          offset += recBuffers[i].length
        }
        return result
      }

      function interleave(inputL, inputR) {
        let length = inputL.length + inputR.length
        let result = new Float32Array(length)

        let index = 0,
          inputIndex = 0

        while (index < length) {
          result[index++] = inputL[inputIndex]
          result[index++] = inputR[inputIndex]
          inputIndex++
        }
        return result
      }

      function floatTo16BitPCM(output, offset, input) {
        for (let i = 0; i < input.length; i++, offset += 2) {
          let s = Math.max(-1, Math.min(1, input[i]))
          output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true)
        }
      }

      function writeString(view, offset, string) {
        for (let i = 0; i < string.length; i++) {
          view.setUint8(offset + i, string.charCodeAt(i))
        }
      }

      /**
       * 编码为wav
       * @param samples 采样点
       * @param sampleRate 采样率
       * @returns {DataView}
       */
      function encodeWAV(samples, sampleRate) {
        let buffer = new ArrayBuffer(44 + samples.length * 2)
        let view = new DataView(buffer)

        /* RIFF identifier */
        writeString(view, 0, 'RIFF')
        /* RIFF chunk length */
        view.setUint32(4, 36 + samples.length * 2, true)
        /* RIFF type */
        writeString(view, 8, 'WAVE')
        /* format chunk identifier */
        writeString(view, 12, 'fmt ')
        /* format chunk length */
        view.setUint32(16, 16, true)
        /* sample format (raw) */
        view.setUint16(20, 1, true)
        /* channel count */
        view.setUint16(22, numChannels, true)
        /* sample rate */
        view.setUint32(24, sampleRate, true)
        /* byte rate (sample rate * block align) */
        view.setUint32(28, sampleRate * 4, true)
        /* block align (channel count * bytes per sample) */
        view.setUint16(32, numChannels * 2, true)
        /* bits per sample */
        view.setUint16(34, 16, true)
        /* data chunk identifier */
        writeString(view, 36, 'data')
        /* data chunk length */
        view.setUint32(40, samples.length * 2, true)

        floatTo16BitPCM(view, 44, samples)

        return view
      }
    }, self)

    this.worker.postMessage({
      command: 'init',
      config: {
        sampleRate: this.context.sampleRate,
        desiredSamplingRate: this.config.sampleRate,
        numChannels: this.config.numChannels,
        origin: window.location.protocol + '//' + window.location.host,
      },
    })

    this.worker.onmessage = e => {
      if (e.data.command == 'getSpeexData') {
        this.getSpeexData && this.getSpeexData(e.data.data)
      } else {
        let cb = this.callbacks[e.data.command].pop()
        if (typeof cb == 'function') {
          cb(e.data.data)
        }
      }
    }
  }

  record() {
    this.node.connect(this.context.destination)
    this.recording = true
    this.worker.postMessage({
      command: 'setRecording',
      status: true,
    })
    this.worker.postMessage({
      command: 'encodeSpeex',
    })
  }

  stop() {
    this.worker.postMessage({
      command: 'setRecording',
      status: false,
    })
    this.recording = false
  }

  close() {
    if (this.context) {
      console.log(this.node)
      this.node.disconnect()
      this.context.close().then(() => {
        console.log('close')
        this.context = null
      })
    }
    if (this.worker) {
      this.worker.terminate()
    }
  }
  clear() {
    this.worker.postMessage({
      command: 'clear',
    })
  }
  encodeSpeex(cb, buffer) {
    cb = cb || this.config.callback
    if (!cb) throw new Error('Callback not set')
    this.callbacks.encodeSpeex.push(cb)
    this.worker.postMessage({
      command: 'encodeSpeex',
      buffer: buffer,
    })
  }
  getConfig() {
    return {
      ...this.config,
    }
  }
  getBuffer(cb) {
    cb = cb || this.config.callback
    if (!cb) throw new Error('Callback not set')
    this.callbacks.getBuffer.push(cb)
    this.worker.postMessage({
      command: 'getBuffer',
    })
  }
  exportWAVAndUpload(url, params = {}, callback) {
    this.exportWAV(function(blob) {
      var fd = new FormData()
      fd.append('speech', blob)
      let sid = params.sid || new Date().getTime()
      fd.append('sid', sid)
      let sound_xml = params.sound_xml || ''
      fd.append('sound_xml', sound_xml);

      var xhr = new XMLHttpRequest()
      if (callback) {
        // xhr.upload.addEventListener(
        //   'progress',
        //   function(e) {
        //     callback('uploading', e)
        //   },
        //   false
        // )
        xhr.addEventListener(
          'load',
          function (e) {
            console.log(e)
            if (xhr.status === 200) {
              // 如果响应成功，获取返回值
              const response = xhr.responseText;
              callback(response); // 调用回调函数并传递响应数据
            } else {
              callback('error', xhr.statusText); // 请求失败，返回状态码或错误信息
            }
          },
          false
        );
        xhr.addEventListener(
          'error',
          function(e) {
            callback('error', e)
          },
          false
        )
        xhr.addEventListener(
          'abort',
          function(e) {
            callback('cancel', e)
          },
          false
        )
      }
      xhr.open('POST', url)
      xhr.setRequestHeader('Accept', 'application/json'); // 设置请求头，如果服务器返回的是JSON
      xhr.responseType = 'text'; // 根据需要设置响应类型，默认是 'text'
      xhr.send(fd)
    })
  }

  exportWAV(cb) {
    const mimeType = 'audio/wav'
    cb = cb || this.config.callback
    if (!cb) throw new Error('Callback not set')

    this.callbacks.exportWAV.push(cb)
    this.worker.postMessage({
      command: 'exportWAV',
      type: mimeType,
    })
  }
  static forceDownload(blob, filename) {
    let url = (window.URL || window.webkitURL).createObjectURL(blob)
    let link = window.document.createElement('a')
    link.href = url
    link.download = filename || 'output.wav'
    let click = document.createEvent('Event')
    click.initEvent('click', true, true)
    link.dispatchEvent(click)
    console.log(link)
  }

  static createRecorder(config) {
    return new Promise((resolve, reject) => {
      // 老的浏览器可能根本没有实现 mediaDevices，所以我们可以先设置一个空的对象
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {}
      }

      // 一些浏览器部分支持 mediaDevices。我们不能直接给对象设置 getUserMedia
      // 因为这样可能会覆盖已有的属性。这里我们只会在没有getUserMedia属性的时候添加它。
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function(constraints) {
          // 首先，如果有getUserMedia的话，就获得它
          var getUserMedia =
            navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia

          // 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
          if (!getUserMedia) {
            return Promise.reject(
              new Error(i18n.tc('media_devices_unsupported_browserLabel'))
            )
          }

          // 否则，为老的navigator.getUserMedia方法包裹一个Promise
          return new Promise(function(resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject)
          })
        }
      }

      if (navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({
            audio: true,
          })
          .then(stream => {
            const AudioContext =
              window.AudioContext || window.webkitAudioContext
            const audioCtx = new AudioContext()
            const input = audioCtx.createMediaStreamSource(stream)
            const rec = new Recorder(input, config)
            resolve(rec)
          })
          .catch(error => {
            console.error(error)
            reject(this.__getUserMediaError(error))
          })
      } else {
        reject({
          message: i18n.tc('media_devices_unsupported_browserLabel'),
        })
      }
    })
  }
  static __settingMediaDevices(navigator) {
    navigator.mediaDevices
      .enumerateDevices()
      .then(e => {
        console.log(e)
        e.map((d, i) => {
          console.log(d, i)
        })
      })
      .catch(error => {
        console.log(error)
      })
  }
  static __getUserMediaError(error) {
    let message = error.message
    let title
    //https://developer.mozilla.org/zh-CN/docs/Web/API/MediaDevices/getUserMedia
    switch (error.name) {
      case 'NotAllowedError':
      case 'PermissionDeniedError':
      case 'NotFoundError':
        title = i18n.tc('media_devices_help_title')
        message = i18n.tc('media_devices_help_content')
        break
      case 'NotReadableError':
        message = i18n.tc('layer_common_notfoundmic')
        break
      default:
        message = error.name + error.message
        break
    }
    return {
      title: title,
      message: message,
    }
  }
}

export default Recorder
